export class ClaimOperator {

    private userVirtualOrganization!: string;
    private userOrganization!: string;
    private userId!: string;
    private userName!: string;
    private userRole!: string;
    private isActive!: boolean;
    private accessStartTimestamp!: Date;
    private accessEndTimestamp!: Date;
    private actions!: Map<Date, string>;


    constructor(claimOperatorDto: any) {
        if (claimOperatorDto) {
            this.userVirtualOrganization = claimOperatorDto.userVirtualOrganization;
            this.userOrganization = claimOperatorDto.userOrganization;
            this.userId = claimOperatorDto.userId;
            this.userName = claimOperatorDto.userName;
            this.userRole = claimOperatorDto.userRole;
            this.isActive = claimOperatorDto.isActive;
            this.actions = claimOperatorDto.actions;

            if (claimOperatorDto.accessStartTimestamp) {
                this.accessStartTimestamp = new Date(claimOperatorDto.accessStartTimestamp);
            }

            if (claimOperatorDto.accessEndTimestamp) {
                this.accessEndTimestamp = new Date(claimOperatorDto.accessEndTimestamp);
            }
        }
    }

    /**
     * Getter $actions
     * @return {Map<Date, string>}
     */
    public get $actions(): Map<Date, string> {
        return this.actions;
    }

    /**
     * Setter $actions
     * @param {Map<Date, string>} value
     */
    public set $actions(value: Map<Date, string>) {
        this.actions = value;
    }

    /**
     * Getter $userVirtualOrganization
     * @return {string}
     */
    public get $userVirtualOrganization(): string {
        return this.userVirtualOrganization;
    }

    /**
     * Getter $userOrganization
     * @return {string}
     */
    public get $userOrganization(): string {
        return this.userOrganization;
    }

    /**
     * Getter $userId
     * @return {string}
     */
    public get $userId(): string {
        return this.userId;
    }

    /**
     * Getter $userName
     * @return {string}
     */
    public get $userName(): string {
        return this.userName;
    }

    /**
     * Getter $userRole
     * @return {string}
     */
    public get $userRole(): string {
        return this.userRole;
    }

    /**
     * Getter $isActive
     * @return {boolean}
     */
    public get $isActive(): boolean {
        return this.isActive;
    }

    /**
     * Getter $accessStartTimestamp
     * @return {Date}
     */
    public get $accessStartTimestamp(): Date {
        return this.accessStartTimestamp;
    }

    /**
     * Getter $accessEndTimestamp
     * @return {Date}
     */
    public get $accessEndTimestamp(): Date {
        return this.accessEndTimestamp;
    }

    /**
     * Setter $userVirtualOrganization
     * @param {string} value
     */
    public set $userVirtualOrganization(value: string) {
        this.userVirtualOrganization = value;
    }

    /**
     * Setter $userOrganization
     * @param {string} value
     */
    public set $userOrganization(value: string) {
        this.userOrganization = value;
    }

    /**
     * Setter $userId
     * @param {string} value
     */
    public set $userId(value: string) {
        this.userId = value;
    }

    /**
     * Setter $userName
     * @param {string} value
     */
    public set $userName(value: string) {
        this.userName = value;
    }

    /**
     * Setter $userRole
     * @param {string} value
     */
    public set $userRole(value: string) {
        this.userRole = value;
    }

    /**
     * Setter $isActive
     * @param {boolean} value
     */
    public set $isActive(value: boolean) {
        this.isActive = value;
    }

    /**
     * Setter $accessStartTimestamp
     * @param {Date} value
     */
    public set $accessStartTimestamp(value: Date) {
        this.accessStartTimestamp = value;
    }

    /**
     * Setter $accessEndTimestamp
     * @param {Date} value
     */
    public set $accessEndTimestamp(value: Date) {
        this.accessEndTimestamp = value;
    }
}
